<template>
    <b-modal
        v-model="modal"
        title="Detail"
        hide-footer
        centered
        @show="setData"
        @hidden="resetData"
    >
        <template v-if="detailData">
            <b-row class="mb-2">
                <b-col><b>username:</b></b-col>
                <b-col>{{ detailData.username }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col><b>AWS Account ID:</b></b-col>
                <b-col>{{ detailData.awsAccountId }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col><b>AWS Account Name:</b></b-col>
                <b-col>{{ detailData.awsAccountName }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col><b>isActive</b></b-col>
                <b-col
                    ><b-badge
                        :variant="detailData.isActive ? 'info' : 'secondary'"
                        >{{ detailData.isActive }}</b-badge
                    ></b-col
                >
            </b-row>
            <b-row class="mb-2">
                <b-col><b>status</b></b-col>
                <b-col>{{ detailData.status }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col><b>created at</b></b-col>
                <b-col>{{ detailData.createdAt }}</b-col>
            </b-row>
        </template>
    </b-modal>
</template>

<script>
import { getAwsAccountDetail } from '@/services/aws.service';

export default {
    name: 'DetailModal',
    props: {
        awsAccountUuid: {
            required: true,
        },
        value: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    computed: {
        modal: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
    data() {
        return {
            detailData: null,
        };
    },
    methods: {
        setData() {
            getAwsAccountDetail(this.awsAccountUuid).then(({ data }) => {
                this.detailData = data;
            });
        },
        resetData() {
            this.detailData = null;
        },
    },
};
</script>

<style scoped></style>
